<!--
Author: TangChen
Date: 2018-09-12
Desc: 执行结果页面，为公共组件
 -->
<template>
    <div class="comp-result comp">
        <div v-if="!result.special" class="result-con">
            <div class="register-box" :class="result.cla">
                <span class="register-img" />
                <p class="register-text">
                    {{ result.msg }}
                </p>
            </div>
            <div class="register-btn border-top" :class="result.cla">
                <span class="register-btn-msg">{{ result.btnMsg?result.btnMsg:'' }}</span>
                <div v-if="result.transfer && result.transfer.payway && result.transfer.payway == '3'" class="transfer-msg">
                    <p class="tit">
                        <span style="color: red;">请用下单时的银行卡在规定时间前完成汇款</span>
                        <span>，汇款信息如下:</span>
                    </p>
                    <div class="info-container">
                        <!-- 公司名称 -->
                        <div class="info-row">
                            <div class="info-content">
                                <i>公司名称：</i><span>{{ result.transfer.acct_name }}</span>
                            </div>
                            <div class="copy-col">
                                <el-button 
                                    size="mini" 
                                    type="text" 
                                    class="copy-btn"
                                    v-on:click="copyToClipboard(result.transfer.acct_name)"
                                >
                                    复制
                                </el-button>
                            </div>
                        </div>
                        
                        <!-- 开户行 -->
                        <div class="info-row">
                            <div class="info-content">
                                <i>开户行：</i><span>{{ result.transfer.issuring_bank }}</span>
                            </div>
                            <div class="copy-col">
                                <el-button 
                                    size="mini" 
                                    type="text" 
                                    class="copy-btn"
                                    v-on:click="copyToClipboard(result.transfer.issuring_bank)"
                                >
                                    复制
                                </el-button>
                            </div>
                        </div>
                        
                        <!-- 银行账号 -->
                        <div class="info-row">
                            <div class="info-content">
                                <i>银行账号：</i><span>{{ result.transfer.acct_no }}</span>
                            </div>
                            <div class="copy-col">
                                <el-button 
                                    size="mini" 
                                    type="text" 
                                    class="copy-btn"
                                    v-on:click="copyToClipboard(result.transfer.acct_no)"
                                >
                                    复制
                                </el-button>
                            </div>
                        </div>
                        
                        <!-- 大额行号 -->
                        <div class="info-row" v-if="result.transfer.cnaps.trim()">
                            <div class="info-content">
                                <i>大额行号：</i><span>{{ result.transfer.cnaps }}</span><i>(异地汇款使用)</i>
                            </div>
                            <div class="copy-col">
                                <el-button 
                                    size="mini" 
                                    type="text" 
                                    class="copy-btn"
                                    v-on:click="copyToClipboard(result.transfer.cnaps)"
                                >
                                    复制
                                </el-button>
                            </div>
                        </div>
                        
                        <!-- 交换号 -->
                        <div class="info-row" v-if="result.transfer.bank_exchange_no.trim()">
                            <div class="info-content">
                                <i>交换号：</i><span>{{ result.transfer.bank_exchange_no }}</span><i>(同城交换使用)</i>
                            </div>
                            <div class="copy-col">
                                <el-button 
                                    size="mini" 
                                    type="text" 
                                    class="copy-btn"
                                    v-on:click="copyToClipboard(result.transfer.bank_exchange_no)"
                                >
                                    复制
                                </el-button>
                            </div>
                        </div>
                        
                        <!-- 大额支付号 -->
                        <div class="info-row" v-if="result.transfer.big_cnaps.trim()">
                            <div class="info-content">
                                <i>大额支付号：</i><span>{{ result.transfer.big_cnaps }}</span>
                            </div>
                            <div class="copy-col">
                                <el-button 
                                    size="mini" 
                                    type="text" 
                                    class="copy-btn"
                                    v-on:click="copyToClipboard(result.transfer.big_cnaps)"
                                >
                                    复制
                                </el-button>
                            </div>
                        </div>
                        
                        <!-- 汇款金额 -->
                        <div class="info-row" v-if="result.transfer.amount.trim()">
                            <div class="info-content">
                                <i>汇款金额(元)：</i><span style="font-weight: bold;color: red">{{ result.transfer.amount }}</span>
                            </div>
                            <!-- <div class="copy-col">
                                <el-button 
                                    size="mini" 
                                    type="text" 
                                    class="copy-btn"
                                    v-on:click="copyToClipboard(result.transfer.amount)"
                                >
                                    复制
                                </el-button>
                            </div> -->
                        </div>
                    </div>
                    <div class="tips">
                        <span class="line" style="font-size:12px">温馨提示：</span><br>
                        <span class="line" style="margin-left: 20px">1、为避免交易失败，请确保汇款总金额与交易金额一致</span><br>
                        <span class="line" style="margin-left: 20px">2、请使用上述银行官方手机银行、网上银行或银行柜台转账汇款</span>
                    </div>
                    <!-- <div class="more-remit" v-on:click="$router.push({name: 'remitinfo'})">
                        查看更多汇款信息
                    </div> -->
                </div>
                <!-- <div v-if="result.transfer" class="transfer-msg">
                    <p class="tit">
                        请按照以下银行信息进行汇款:
                    </p>
                    <p><i>公司名称：</i><span>{{ $cache.getCompanyInfo().companyname }}</span></p>
                    <p><i>开户行：</i><span>{{ result.transfer.remitbankbranch }}</span></p>
                    <p><i>银行账户名：</i><span>{{ result.transfer.remitacctname }}</span></p>
                    <p><i>银行账号：</i><span>{{ result.transfer.remitcardnum }}</span></p>
                    <div class="more-remit" v-on:click="$router.push({name: 'remitinfo'})">
                        查看更多汇款信息
                    </div>
                </div> -->
                <el-row v-if="result.btnL||result.btnR" :class="{'padbot':!result.btnMsg}">
                    <el-button v-if="result.btnL.text" type="primary" v-on:click.once="eventBtn('btnL')">
                        {{ result.btnL.text }}
                    </el-button>
                    <el-button v-if="result.btnR.text" v-on:click.once="eventBtn('btnR')">
                        {{ result.btnR.text }}
                    </el-button>
                    <div v-if="result.btnR.ctd" class="count-down">
                        <span v-if="time>0">{{ time }}</span>{{ result.btnR.ctd }}
                    </div>
                </el-row>
            </div>
        </div>
        <div v-show="result.special" class="result-buy-con">
            <el-steps class="result-msg" :active="active" align-center>
                <template v-if="result.btnGroup">
                    <el-step
                        v-for="(btn,index) in result.btnGroup"
                        :key="index"
                        :icon="'el-icon-cust index0'+ index"
                        :title="btn.tit"
                        :description="btn.text"
                    >
                        <i slot="prepend" class="el-icon-upload">123123</i>
                    </el-step>
                </template>
            </el-steps>
            <el-row class="btn-group">
                <template v-if="result.btnGroup">
                    <el-col v-for="(btn,index) in result.btnGroup" :key="index" :span="8">
                        <el-button
                            v-if="btn.btn"
                            :type="index===0?'primary':''"
                            :class="{'border-blue':index===1}"
                            v-on:click.once="toPage(btn.url)"
                        >
                            {{ btn.btn }}
                        </el-button>
                    </el-col>
                </template>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    name: "Result",
    props: {
        result: {
            type: Object,
            required: true
        },
        active: {
            type: Number,
            default: 1
        }
    },
    data () {
        return {
            time: 0,
            btnMsg: ""
        };
    },
    mounted () {
        if (this.result.btnR.ctd) {
            if (this.result.btnR.time > 0) {
                this.time = this.result.btnR.time;
                this.$util.btnDisabled(this, function (_this) {
                    _this.$emit(_this.result["btnR"].event);
                });
            }
        }
    },
    methods: {
        eventBtn (v) {
            this.$emit(this.result[v].event);
        },
        toPage (val) {
            if (val === "return") {
                return this.$emit("return-page");
            }
            this.$router.push({ name: val });
        },
        // 复制方法
        copyToClipboard(text) {
            if (!text) {
                this.$message({
                    type: "warning",
                    message: "无内容可复制!"
                });
                return;
            }
        
            // 现代浏览器（推荐）
            if (navigator.clipboard) {
                navigator.clipboard.writeText(text)
                    .then(() => {
                        this.$message({
                            type: "success",
                            message: "复制成功"
                        });
                    })
                    .catch(err => {
                        this.$message({
                            type: "error",
                            message: "复制失败，请手动复制"
                        });
                    });
            } 
            // 兼容旧浏览器（如IE）
            else if (document.execCommand) {
                const textArea = document.createElement("textarea");
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.select();
                try {
                    document.execCommand("copy");
                    this.$message({
                        type: "success",
                        message: "复制成功"
                    });                
                } catch (err) {
                    this.$message({
                        type: "error",
                        message: "复制失败，请手动复制"
                    });
                } finally {
                    document.body.removeChild(textArea);
                }
            } else {
                this.$message({
                    type: "error",
                    message: "您的浏览器不支持复制功能，请手动复制"
                });                
            }
        }        
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-result {
    text-align: center;
    .register-box {
        padding: 30px 0 15px;
        .register-img {
            display: inline-block;
            width: 88px;
            height: 88px;
        }
        .register-text {
            padding-top: 7px;
            color: $text-color2;
            font-size: $f24;
            line-height: 40px;
        }
    }
    .transfer-msg {
        width: 550px;
        margin: 0 0 20px 415px;
        text-align: left;
        .tips {
            margin-top: 10px;
            .line {
                line-height: 26px;
                text-indent: 2em;
            }
        }
        .more-remit {
            cursor: pointer;
            color: #26a2ff;
            line-height: 20px;
            text-align: right;
            &:hover {
                color: #1e84d1;
            }
        }
        .info-container {
            display: flex;
            flex-direction: column;
        }

        /* 信息行 */
        .info-row {
            display: flex;
            align-items: center;
            margin-bottom: 8px; /* 行间距 */
            font-size: $f16;
            line-height: 36px;
            color: $text-color3;
        }

        /* 信息内容区域 */
        .info-content {
            flex: 1; /* 占据剩余空间 */
            padding-right: 15px; /* 与复制列间距 */
            span {
                color: $text-color2;
            }
            i {
                font-style: normal;
                display: inline-block;
                width: 120px;
                text-align: right;
            }
        }

        /* 复制按钮列 */
        .copy-col {
            width: 80px; /* 固定宽度确保列对齐 */
            // text-align: right; /* 按钮右对齐 */
        }

        /* 复制按钮样式 */
        .copy-btn {
            padding: 4px 8px;
            font-size: 12px;
            color: #1e84d1;
        }
        p {
            font-size: $f16;
            line-height: 36px;
            color: $text-color3;
            &.tit {
                font-size: $f14;
            }
            span {
                color: $text-color2;
            }
            i {
                font-style: normal;
                display: inline-block;
                width: 120px;
                text-align: right;
            }
        }
    }
    .register-btn {
        padding-bottom: 29px;
        .register-btn-msg {
            color: $text-color1;
            line-height: 30px;
            padding: 19px 0 17px;
            display: block;
        }
        .el-row {
            &.padbot {
                padding-bottom: 100px;
            }
            .el-button {
                min-width: 165px;
            }
            .el-button + .el-button {
                margin-left: 20px;
            }
            .count-down {
                font-size: $f16;
                color: $text-color3;
                display: inline-block;
                margin-left: 18px;
                span {
                    color: $color-b;
                    padding: 0 2px;
                }
            }
        }
    }
    .register-box.register-success {
        .register-img {
            background: url("../../assets/img/icon-result.png") 0 0 no-repeat;
        }
    }
    .register-box.register-fail {
        .register-img {
            background: url("../../assets/img/icon-result.png") -104px 0 no-repeat;
        }
    }
    .result-buy-con {
        .result-msg {
            position: relative;
            width: 960px;
            margin: 80px auto 46px;
            .el-step__description {
                font-size: $f14;
                &.is-process,
                &.is-finish {
                    color: $text-color1;
                }
            }
            .el-step.is-horizontal .el-step__line {
                top: 35px;
                left: 65%;
                right: -35%;
            }
            .el-step__head.is-finish {
                color: $color-b;
                border-color: $color-b;
                .el-step__icon.is-icon {
                    background-color: $color-b;
                }
            }
            .el-step__icon.is-icon {
                width: 71px;
                height: 71px;
                background-color: #acafb1;
                border-radius: 50%;
                .el-step__icon-inner {
                    width: 47px;
                    height: 47px;
                }
                .index00 {
                    background: url($icon) -204px -34px no-repeat;
                }
                .index01 {
                    background: url($icon) -265px -34px no-repeat;
                }
                .index02 {
                    background: url($icon) -324px -36px no-repeat;
                }
            }
            .el-step__title {
                font-size: $f20;
                &.is-process {
                    color: $text-color2;
                    font-weight: normal;
                }
                &.is-finish {
                    color: $color-b;
                }
            }
        }
        .el-row.btn-group {
            width: 616px;
            margin: 0 auto;
            .el-col {
                text-align: center;
                .el-button {
                    width: 150px;
                    &.border-blue {
                        border-color: $color-b;
                        color: $color-b;
                        &:hover,
                        &:focus {
                            background-color: #e7f2fa;
                        }
                    }
                }
            }
        }
    }
}
</style>
